import React from 'react';
import ServicePage from './ServicePage';
import { IconCloud, IconLeaf, IconFileText, IconCheckCircle } from '../../components/Icons';

const DATA = {
  icon: <IconCloud size={32} />, category: 'ambiental',
  title: 'Huella de Carbono',
  subtitle: 'Cuantificación, reporte y gestión de las emisiones de gases de efecto invernadero (GEI) conforme a estándares internacionales y normativa colombiana.',
  norm: 'GHG Protocol – ISO 14064 – Resolución 2202/2016 MADS',
  desc: 'Apoyamos a empresas y proyectos del sector minero-energético en la medición, verificación y gestión de su Huella de Carbono. Cuantificamos las emisiones de GEI en los Alcances 1, 2 y 3, formulamos estrategias de reducción y acompañamos el reporte ante el Sistema de Información de Registro de Emisiones (SIRE) del Ministerio de Ambiente.',
  details: [
    'Inventario de emisiones GEI: Alcances 1, 2 y 3',
    'Cuantificación según GHG Protocol e ISO 14064-1',
    'Factores de emisión nacionales e internacionales actualizados',
    'Identificación de fuentes fijas, móviles y fugitivas',
    'Plan de reducción y estrategias de compensación',
    'Reporte ante el SIRE – Ministerio de Ambiente y Desarrollo Sostenible',
    'Verificación de tercera parte y declaración de huella',
    'Seguimiento anual y mejora continua del inventario',
  ],
  related: [
    { icon: <IconLeaf size={18} />,     label: 'PMA',              path: '/servicios/pma' },
    { icon: <IconFileText size={18} />, label: 'Licencias Ambientales', path: '/servicios/licencias' },
    { icon: <IconCheckCircle size={18} />, label: 'ICAS',          path: '/servicios/icas' },
  ],
};

export default function HuellaCarbone() { return <ServicePage data={DATA} />; }
